<template>
  <div>
    <GroupsForm />
  </div>
</template>

<script>
import GroupsForm from '../components/GroupsForm.vue'

export default {
  components: { GroupsForm },
}
</script>

<style>

</style>
